var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdgeEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8038_3461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 22C17.5229 22 22 17.523 22 12C22 6.477 17.5229 2 11.9998 2C6.47711 2 2 6.477 2 12C2 17.523 6.47711 22 11.9998 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_8038_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2398 7.2002L10.5598 15.8402L5.75977 12.0002",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8038_3461",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BC495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B5A44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8038_3461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeEnabled);
export default __webpack_public_path__ + "static/media/Edge-Enabled.ebe5cde593ec929ed3d488f03324095d.svg";
export { ForwardRef as ReactComponent };